<template>
    <Overlay :show="loading">
        <RegulationQuestions
            :groups="groups"
            :legislations="legislations"
            :answers="answers"
            @answersChange="$emit('answersChange', $event)"
        />
    </Overlay>
</template>

<script>
import Overlay from '@core/components/common/Overlay.vue'
import RegulationQuestions from '@/views/product/components/product-card/RegulationQuestions.vue'

export default {
    name: 'FurtherProductInformation',
    components: {
        Overlay,
        RegulationQuestions,
    },
    props: {
        groups: {
            type: Array,
            default() {
                return []
            },
        },
        legislations: {
            type: Array,
            default() {
                return []
            },
        },
        answers: {
            type: Array,
            default() {
                return []
            },
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
